import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from '../tokenHandling/prepareHeaders';

const RETRY_DELAY_MS = 1000;

const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const baseQueryWithReauth = (baseUrl: string): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {
    const rawBaseQuery = fetchBaseQuery({ baseUrl, prepareHeaders });

    return async (args, api, extraOptions) => {
        let result = await rawBaseQuery(args, api, extraOptions);

        if (result.error?.status === 401) {
            // Token may have been refreshed by oidc-client-ts in the background.
            // Wait briefly to allow the silent renew callback to save the new token,
            // then retry with the (potentially updated) token.
            await wait(RETRY_DELAY_MS);
            result = await rawBaseQuery(args, api, extraOptions);
        }

        return result;
    };
};
